import React from "react";

const SvgSemaforYellowAml = props => (
    <svg viewBox="0 0 110 110" {...props}>
        <defs>

            <linearGradient
                id="semafor_yellow_aml_svg_item_2"
                x1={47.74}
                y1={61.95}
                x2={61.9}
                y2={47.79}
                gradientTransform="matrix(1 0 0 -1 0 111.28)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#fff" stopOpacity={0} />
                <stop offset={1} stopColor="#221a00" />
            </linearGradient>
            <linearGradient
                id="semafor_yellow_aml_svg_item_2-2"
                x1={76.05}
                y1={61.95}
                x2={90.21}
                y2={47.79}
                xlinkHref="#semafor_yellow_aml_svg_item_2"
            />
            <linearGradient
                id="semafor_yellow_aml_svg_item_2-3"
                x1={19.38}
                y1={61.95}
                x2={33.54}
                y2={47.79}
                xlinkHref="#semafor_yellow_aml_svg_item_2"
            />
            <style>
                {
                    ".semafor_yellow_aml_svg__cls-2{opacity:.5;isolation:isolate}.semafor_yellow_aml_svg__cls-3{fill:#fff}"
                }
            </style>
        </defs>
        <g id="semafor_yellow_aml_svg__Vrstva_2" data-name="Vrstva 2">
            <g id="semafor_yellow_aml_svg__Vrstva_1-2" data-name="Vrstva 1">
                <g id="semafor_yellow_aml_svg__\u017Dlut\xFD">
                    <circle
                        cx={55}
                        cy={55}
                        r={55}
                        fill={`url('${window.location.pathname}#bg-semafor-yellow')`}
                    />
                    <image
                        className="semafor_yellow_aml_svg__cls-2"
                        width={43}
                        height={43}
                        transform="matrix(.76 0 0 .76 38.77 40.07)"
                        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAAA6cAAAOnAEHlFPdAAAEvUlEQVRYR9WY63LTSBBGzzgXOzFxEgILqV14//eigMpi4mA7VzvW/uj5Mq2RZMk2S0FXdSlxSTNnPvX0dCsURcGfZL22G34322+7oauFEEL+W/E/vL6w7ZgOMDjPrXD+UxawMXAElfdqXLaq8QLj3mxSZ52BHajA9p0fxGsv3lNggEtgEa9L4Dn6ii3BOwFH2B6wh8EdAP3og+iHJGjBPgEPwGO8PkUX/MbgrcAhBCl6gEENgGNgCLyKfgwcxXv2MJgFcA/cAXPgNv59R4JfxHtXXaHXAkdYqTrAIEfAKXAWfQScYNB9ksKPGNws+o/o0/j/LbagF8W7QDemNQd7iKl3ApwDb5y/xqDXAc8x0AlwDXyP1wkGP49TFiGEVqVrgV3MHmCwp8AF8A54H/2v+NspFhYKCQErJG4xsAkGexbv72OCyApgEUJYm/4qwBnsAFPvArgE/ol+iQGfk2D7cTxlCW06QV/E+0ekxfmM8uyu3YGxQRQKQ2ySdxjoR+ADpvAFaXKp5RVTCnvCFn1C2qCHlN9EaQOGEEKTyiXgGnVHWKy+x4A/AH8Db7FQ0OR7pBws1aScMotcYaPF3JNSn6BfTsfccoU98DEGJeDLeH2Lqa5N5mFzKygfMAqZuiwyJ2WN5yaVX4DdSbaPgQyxDfIGi1e/yQSrgwLqgfW7rzX8hpwBN1jWuMGgH7D4X1VGolpe6sjtY/F2hqUuv2G2hfX5/BW28PPoSo0+ZGrH9CGhcNgnDTrCBvOpy8esnmsz3eMF8YfQafy/FdgrnG+4Y6q728esnulqdUrreB9i4w9wRVRdjd2DUvx6BY7iQEOSsr4i2wRWpjkErXmOSOr6UKtYXQz7weSHpFfVOFhH89AqTTV+qyD55Plg8nWpaxML7urnkkuQxnl2Vetnmc+3a4ufHNif60vKnYJanF2scFc/T6kTYc08ObAGWWAnkVxnvXqzXcyDqo7QPK1Hcw9eulnfhz2Sqqy80G5VocHyOVRH5F2In6NiXmENtsAezs/5O2whenV6povpPg+r4n5KKuQfcCrX1RJ1wMv4oAa7wToGX5z4s74Nugl2hhX1E8rjK/RqLa/WfEjMSYXJd1LRo8Jbz+enpSzfYB72BzbuOPo1Jo4HXl9eFkVRhBAKEvAtBjwm1RIDLF8GbEB/+vWoTqJN6mEnccyr6P/G3+bYvEto7qJzhX0cS4lvlM95sBjzBbwOl1xhZQOv7Bj4AnwGvmLj32ACaY80hlkJOKrsN94UAxIUpE7hgdQte2hZDjvDXv0VBvsJAx+TwmGtulBVGJIyT9iqfa/2TAqXKeUmVB9RFC7+Y8qccih8xWCvsEXMSZt57SauAGcq+yLEh4o6BV/US2UBe3XV5o+xmP1G2mwzUjrb7rtEBg0ptj3ANRbHeRfigdW3TUmZYYItNs+9rbDQAAxQFMUq1s86oXyXK4X1bW1AKu59SOgj4JyU1/WdTTldsJ2O/C4fA31hr+I+L7xVz9bFsDbofXTVDSqsOikrawWGSkfiC2+5r5lleZEjL1V/m8BCR2BZBi7PP6JIYbnAV843BpVtBCxz4FAGzc2Dww6gsq2AvdV1trntCultZ+Bfbb9LT9fZ/jjg/wATAWzMs1wfiAAAAABJRU5ErkJggg=="
                    />
                    <circle
                        className="semafor_yellow_aml_svg__cls-3"
                        cx={54.82}
                        cy={56.41}
                        r={10.01}
                    />
                    <circle
                        cx={54.82}
                        cy={56.41}
                        r={10.01}
                        style={{
                            isolation: "isolate"
                        }}
                        fill={`url('${window.location.pathname}#semafor_yellow_aml_svg_item_2')`}
                        opacity={0.25}
                    />
                    <image
                        className="semafor_yellow_aml_svg__cls-2"
                        width={43}
                        height={43}
                        transform="matrix(.76 0 0 .76 67.08 40.07)"
                        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAAA6cAAAOnAEHlFPdAAAEwElEQVRYR9WY63LbNhBGD3yTbMWyXSdNPG36/u/VSTNuFMuR5KtksT8Wn7GEQFIXTyfZmR3aGnJx8HGxWDBUVcWvZHtdN/xsdtB1wyYWQgj5b9Ubv8KwSzwHGJznVjnfeQJbAUdQ+V7BZcuCVxj35gOzIbADFdiB88N43Yv3VBjgApjH6wJ4ib5kC/C1gSPsHrCPwR0Cvej96EckaME+A4/AU7w+Rxf8RuBrAYcQpOghBtUHToAB8C76CXAc79nHYObAA3APzIC7+Pc9CX4e712uA90JHGGlah+DHAJnwHn0IXCKQfdICj9hcNPoP6JP4v932IReFe+Cbi1rDvYIU+8UuADeO/8Ng24DnmGgY+AG+B6vYwx+FoesQgitSjcCu5w9xGDPgEvgI/Ap+u/xtzMsLZQSAlZK3GFgYwz2PN7fwwSRVcA8hNBY/orAGWwfU+8SuAL+jH6FAV+QYHtYTFUJLTpBX8b7h6TJ+Yry4q7rA2NBlAoDbJCPGOhfwGdM4UvS4FLLK6YS9oxN+pS0QI+ov4naAgwhhJLKK8AFdYdYrn7CgD8DfwAfsFTQ4PukGizVpJwqi1xpo8k8kEqfoF93R28lhT3wCQYl4Kt4/YCprkXmYXOrqG8wSplSFZmRqsZLSeUasNvJDjCQAbZA3mP56heZYLVRQBlYv/tewy/IKXCLVY1bDPoRy/9lHqjUXmrL7WH5do6VLr9gtoX19fwdNvGL6CqNPmVWYuYpoXQ4IAUdYsF86fI5q+e6TPd4QfwmdBb/bwXOFc4X3Amrq9vnrJ5Z10pKa3sfYPH7uCYq77FfgbNOTAocx0ADkrK+I9sEVqYxBK1xjknq+lSrWVMO+2DyI9KrKgbbwDy0WlPFbxWkNHAeTN5Wujax4K5+LLkEKY6zq1Jvab7eNjY/JWC/ry+onxR0xNnFKnf149ROIjSMUwJWkDm2E8m11+tstot5UPURGqd1a34FjlugP4c9kbqsvNFuVaHF8jHUR+SnED9GzXKFFWyOPZzv8/fYRPTq9Mw6pvs8rJr7CamRf8SpnPcSTcCL+KCC3WInBt+c+L2+C7oJdoo19WPq8ZV6K1bq1nxKzEiNyXdS06PGWzH8xH05yheYh/2BxR1Fv8HE8cDt7WVVVVUIoSIB32HAI1Iv0cfqZcAC+t1vj9VBtEg97DjGvI7+b/xtho27gPIpuqSwz2Mp8Y36Pg+WY76B1+aSK6xq4JUdAf8AX4CvWPxbTCCtkWKarQBHlf3Cm2BAgoJ0UngknZY9tCyHnWKv/hqD/RsDH5HSoVFdKCsMSZlnbNb+rPZCSpcJ9UOoPqIoXfzHlBn1VPiKwV5jk5iRFnPjIi4CZyr7JsSnik4KvqmXygL26uqYP8Jy9htpsU1J5Wy77xIZNKTc9gA3WB7npxAPrHPbhFQZxthk89rb+bmqERigqqpl7J+1Q/lTrhTWt7U+qbn3KaGPgDNSXdd3NtV0wXZu+Z3f1gB/9FerqR7ZN97qZ0s5rAX6EF19gxqrTmVlawHDyonEN95y3zPL8iZHXuv+1oWFDYBlGbg8/4giheUCXzrfCFS2MbDMgUMdNDcPDluCyrYG9pafbEu2C6S3NwH+P+1nOtOtZb8c8H/8z2zM/hEDjQAAAABJRU5ErkJggg=="
                    />
                    <circle
                        className="semafor_yellow_aml_svg__cls-3"
                        cx={83.13}
                        cy={56.41}
                        r={10.01}
                    />
                    <circle
                        cx={83.13}
                        cy={56.41}
                        r={10.01}
                        style={{
                            isolation: "isolate"
                        }}
                        fill={`url('${window.location.pathname}#semafor_yellow_aml_svg_item_2-2')`}
                        opacity={0.25}
                    />
                    <image
                        className="semafor_yellow_aml_svg__cls-2"
                        width={43}
                        height={43}
                        transform="matrix(.76 0 0 .76 10.41 40.07)"
                        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAsCAYAAADxRjE/AAAACXBIWXMAAA6cAAAOnAEHlFPdAAAExElEQVRYR9WYfVPbRhCHn+PNBoKBkjRh2vT7f69Om6FxMLHNq8HqH3s/bnU+WZJNO8nO7Ag88t5zP++tdhWqquJns522G35E22u7oY+FEEL+WfUf/JRhm5gOMjjPrXL+JpvYCDrCyncKLlsWvMLY+y8crRe0gxXcnvP9eN2J91QY5DOwiNdn4CX6kg3hO0NH4B1gFwPcBwbRh9EPSOACfgIegMd4fYquDfSG7wQdQpCy+xjYEDgCjoF30Y+Aw3jPLga0AO6BO2AO3Ma/70gbWMR7l13BW6EjsNQdYqAj4BQ4iz4CTjDwAUnpRwxwFv179Gn8/xbb1KvyXcDXljwHfICpeAKcA++d/4KBr4OeY7AT4Br4Fq8TbAPzuGQVQmhVvBHa5fA+BnwKXAAfgU/Rf42fnWIpovQQtNLjFoObYMBn8f4BJoqsAhYhhLWlsQidAQ8xFS+AS+D36JcY9DkJeIDFVPXQQRT4Rbx/RNqgrzQv7toPGguktDjGFvqIwf4BfMaUviABSDWvnMrbE7bxE9KhPaD+i9QOZQghNKm9Al1QeYTl7icM+jPwG/ABSwsB7JJqtNSTgqo4cqWQNnRPKosCf32K5lZS2kMfYWCCvozXD5j6OngeOLeK+kNI6VOqLnNSNXlpUrsG7Z54exjMMXZo3mP56w+egPUwgTK0Pve9iT+kM+AGqyY3GPgDdh6WK5Eot6Z6PA+w/DvDypo/RJsC+3r/Dtv8eXSVTZ8+xZh5eig19kiBR1hAX9Z8Dut7baZ7vCj+QXUa/2+FzpXOD+ERq6fe57C+09VKiqsVOMbiD3GNV6lHf4XOOjgpcRiDHZMU9p1cH2CZ1hC41jkkqezTbsWactoHlB+QfrbGgB3Ng6utVfxWUUqL5wHl68paHwvu6teSS5TGdbZV7C3N1+O1DVMJ2vcBz9QnDo1L21jlrn6d2kTDmnVK0Aq0wJ5YcvUGmvW2MQ+rvkPrtD7GX6Hj49LPdY+k7ixv1lvVaLB8DfUd+TTj11ixXGkFXGAB8r7gDtuMfkZ9p4vpPg+sAWFKGgYecGqXeo8m6Gfsywp4g00evqHxvUEbeBPwDBsMJtTjKw2LVuryfHrMSc3MN1KjpOZdMfzmfanKD50H/o7FHUe/xgTy0O2taVVVVQihIkHfYtBjUu8xxOppwIL6p+QOqwvp4HrgSYx5Ff2f+NkcW/cZmqfzktI+r6XIV+p9AVjO+SFAD6BcaVUJr/AY+Bv4C/iCxb/BRNKZaUy5Feiotj+MUwxKYJAmjgfSFO7BZTnwDEuDKwz4Twx+TEqNtSpDWWlICj1hu/ez3wspdabUB1u9qFHq+Bc2c+pp8QUDvsI2Micd8LUHuwidqe0bF582mjj8YCC1Be1V1iuEMZbDX0kHcEYqdZu/98jAIeW6h7jG8jqfZjy05sApqWJMsA3ntbkVGNZAA1RVtYw9uJ5kfnqW0nqXNyQNCD499OJxTqr7eq+nmi/gTu1B67s8wL9WUJuqHts37+qHSzmtQ3sfXX2GmrFOCss6QcPKZOObd7nvuWV5YySvdY19gKEHtCyDl+cvaqS0XPBL571hZb2hZQ4e6rC5eXjYAla2MbS30sSc27ag3t4E+v+2H2lG7Gw/JfS/gbZszODgw8QAAAAASUVORK5CYII="
                    />
                    <circle
                        className="semafor_yellow_aml_svg__cls-3"
                        cx={26.46}
                        cy={56.41}
                        r={10.01}
                    />
                    <circle
                        cx={26.46}
                        cy={56.41}
                        r={10.01}
                        style={{
                            isolation: "isolate"
                        }}
                        fill={`url('${window.location.pathname}#semafor_yellow_aml_svg_item_2-3')`}
                        opacity={0.25}
                    />
                </g>
            </g>
        </g>
    </svg>
);

export default SvgSemaforYellowAml;

